import { serviceUserFrag } from '../../../../../services/types/user.types';
import { voucherPrescribedMedicalProcedureFrag } from '../../../../../services/types/voucher.types';

export const getVoucherDetailFrag = `
    id
    folderId
    type
    insuranceNumber
    insuranceAbbr
    insuranceType
    insuredSince
    sequenceNumber
    issueDate
    validTo
    voucherTo
    closureDate
    doctorId
    doctor {
        ${serviceUserFrag}
    }
    prescribedProcedures(input: __PRESCRIBED_PROCEDURES_INPUT__) {
        ${voucherPrescribedMedicalProcedureFrag}
    }
    primaryDiagnosis {
        code
        name
        sex
        ageFrom
        ageTo
        sign
        selectable
        bonifications {
            expertise
            validFrom
            validTo
        }
    }
    secondaryDiagnoses {
        reporting
        diagnosis {
            code
            name
            sex
            ageFrom
            ageTo
            sign
            selectable
            bonifications {
                expertise
                validFrom
                validTo
            }
        }
    }
    compensation {
        code
        description
        priority
    }
    note
    situation
`;
